import type { ColumnsType } from 'antd/lib/table';
import type { ResellersDataItem } from '../queries/getResellersData';
import { ActionTableButton } from '../components/ActionTableButton';

export const getColumns = (onEdit: (reseller: ResellersDataItem) => void): ColumnsType<ResellersDataItem> => [
  {
    title: 'Reseller',
    key: 'reseller',
    dataIndex: ['name'],
    sorter: true,
    width: 400,
  },
  {
    title: 'Trial establishments',
    key: 'trial_establishments',
    dataIndex: ['trial_establishments_pool_size'],
    sorter: true,
    width: 200,
    render: (_, { trial_establishments_pool_size }) => trial_establishments_pool_size ?? 0,
  },
  {
    title: 'Meters offline',
    key: 'meters_offline',
    dataIndex: ['trial_meters_offline_pool_size'],
    sorter: true,
    width: 200,
    render: (_, { trial_meters_offline_pool_size }) => trial_meters_offline_pool_size ?? 0,
  },
  {
    title: 'Meters online',
    key: 'meters_online',
    dataIndex: ['trial_meters_online_pool_size'],
    sorter: true,
    width: 200,
    render: (_, { trial_meters_online_pool_size }) => trial_meters_online_pool_size ?? 0,
  },
  {
    title: 'Actions',
    key: 'actions',
    align: 'center',
    width: 100,
    render: (_, reseller) => <ActionTableButton onEdit={() => onEdit(reseller)} />,
  },
];
